// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__nhTpO","overflowing":"ReadFullNote_overflowing__2QGQE"};